function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import StyledLink from "./styles";
import { themes, sizes } from "./themes";

const Link = props => {
  const {
    className,
    children,
    appearance,
    variation,
    size,
    type,
    href,
    title,
    target,
    onClick,
    id,
    ...rest
  } = props;
  const theme = { ...themes[appearance][variation],
    ...sizes[size],
    size,
    type
  };
  const attributes = {
    id,
    href,
    title,
    target,
    onClick
  };

  if (target === "_blank") {
    attributes.rel = "noopener noreferrer";
  }

  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    className: className,
    theme: theme
  }, attributes, rest), children);
};

Link.defaultProps = {
  appearance: "flat",
  type: "default",
  size: "inherit",
  variation: "default"
};
export default Link;